// Tarih/saat utility fonksiyonları - Timezone dönüşümü yapmadan
export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  try {
    // Veritabanından gelen tarihi direkt parse et (timezone dönüşümü yapmadan)
    if (dateTimeString.includes('T')) {
      // ISO format: 2024-01-15T14:30:00.000Z
      const [date, time] = dateTimeString.split('T');
      const [year, month, day] = date.split('-');
      const [hour, minute] = time.split(':');
      return `${day}.${month}.${year} ${hour}:${minute}`;
    } else if (dateTimeString.includes(' ')) {
      // MySQL DATETIME format: 2024-01-15 14:30:00
      const [date, time] = dateTimeString.split(' ');
      const [year, month, day] = date.split('-');
      const [hour, minute] = time.split(':');
      return `${day}.${month}.${year} ${hour}:${minute}`;
    } else {
      // Fallback
      return dateTimeString;
    }
  } catch (error) {
    console.error('Tarih format hatası:', error);
    return dateTimeString;
  }
};

export const formatDateOnly = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  try {
    if (dateTimeString.includes('T')) {
      const [date] = dateTimeString.split('T');
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    } else if (dateTimeString.includes(' ')) {
      const [date] = dateTimeString.split(' ');
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    } else {
      return dateTimeString;
    }
  } catch (error) {
    console.error('Tarih format hatası:', error);
    return dateTimeString;
  }
};

export const formatTimeOnly = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  try {
    if (dateTimeString.includes('T')) {
      const [, time] = dateTimeString.split('T');
      const [hour, minute] = time.split(':');
      return `${hour}:${minute}`;
    } else if (dateTimeString.includes(' ')) {
      const [, time] = dateTimeString.split(' ');
      const [hour, minute] = time.split(':');
      return `${hour}:${minute}`;
    } else {
      return dateTimeString;
    }
  } catch (error) {
    console.error('Saat format hatası:', error);
    return dateTimeString;
  }
};

// Input için tarih/saat formatı (HTML datetime-local için)
export const formatForInput = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  try {
    if (dateTimeString.includes('T')) {
      // ISO format: 2024-01-15T14:30:00.000Z -> 2024-01-15T14:30
      return dateTimeString.substring(0, 16);
    } else if (dateTimeString.includes(' ')) {
      // MySQL DATETIME format: 2024-01-15 14:30:00 -> 2024-01-15T14:30
      return dateTimeString.replace(' ', 'T').substring(0, 16);
    } else {
      return dateTimeString;
    }
  } catch (error) {
    console.error('Input format hatası:', error);
    return dateTimeString;
  }
};

// Modal input'ları için tarih ve saat ayırma (timezone dönüşümü yapmadan)
export const parseDateTimeForInputs = (dateTimeString) => {
  if (!dateTimeString) return { date: '', startTime: '', endTime: '' };
  
  try {
    let date, startTime, endTime;
    
    if (dateTimeString.includes('T')) {
      // ISO format: 2024-01-15T14:30:00.000Z
      const [datePart, timePart] = dateTimeString.split('T');
      const [year, month, day] = datePart.split('-');
      const [hour, minute] = timePart.split(':');
      
      date = `${year}-${month}-${day}`;
      startTime = `${hour}:${minute}`;
    } else if (dateTimeString.includes(' ')) {
      // MySQL DATETIME format: 2024-01-15 14:30:00
      const [datePart, timePart] = dateTimeString.split(' ');
      const [year, month, day] = datePart.split('-');
      const [hour, minute] = timePart.split(':');
      
      date = `${year}-${month}-${day}`;
      startTime = `${hour}:${minute}`;
    } else {
      return { date: '', startTime: '', endTime: '' };
    }
    
    return { date, startTime, endTime };
  } catch (error) {
    console.error('DateTime parse hatası:', error);
    return { date: '', startTime: '', endTime: '' };
  }
};
